<template>
  <div v-visibility-change="visibilityChange" class="new_gnb">
    <IEServiceEndToast v-if="isIE" />

    <header v-click-outside="hideMenu" class="new_header">
      <div class="header-item header-item__left">
        <!-- 하이웍스 로고 -->
        <LinkedHwLogo :viewType="viewType" />
        <!-- 메뉴 토글 버튼 -->
        <Menu
          :bookmark-add-visible-type="bookmarkAddVisibleType"
          :bookmark-list="bookmarkList"
          :domain="domain"
          :group-list="processedGroupList"
          :intranet-list="intranetList"
          :is-bookmark-order-setting-visible="isBookmarkOrderSettingVisible"
          :is-menu-detail-visible="isMenuDetailVisible"
          :is-menu-visible="isMenuVisible"
          :is-show-plus-app-privacy-dialog="isShowPlusAppPrivacyDialog"
          :isShowIntranetBookmarkPrivacyDialog="isShowIntranetBookmarkPrivacyDialog"
          :menu-info-list="menuInfoList"
          :menu-name="menuName"
          :my-plus-app-list="myPlusAppList"
          :office-account-info="officeAccountInfo"
          :privacyDocList="privacyDocList"
          :selectedIntranetBookmark="selectedIntranetBookmark"
          :selectedPlusApp="selectedPlusApp"
          @toggle-menu="toggleMenu"
          @set-menu-detail-visible="setMenuDetailVisible"
          @set-menu-visible="setMenuVisible"
          @set-intranet-visible="setIntranetVisible"
          @set-bookmark-visible="setBookmarkVisible"
          @set-group-visible="setGroupVisible"
          @set-my-plus-app-visible="setMyPlusAppVisible"
          @create-bookmark="createBookmark"
          @modify-bookmark="modifyBookmark"
          @remove-bookmark="removeBookmark"
          @modify-bookmark-order="modifyBookmarkOrder"
          @set-bookmark-order-setting-visible="setIsBookmarkOrderSettingVisible"
          @set-bookmark-add-visible-type="setBookmarkAddVisibleType"
          @modify-menu-order="modifyMenuOrder"
          @click-plus-app="clickPlusApp"
          @close-plus-privacy-check-dialog="closePlusPrivacyCheckDialog"
          @click-accept-plus-app-privacy="clickAcceptPlusAppPrivacy"
          @click-intranet="clickIntranet"
          @click-accept-intranet-bookmark-privacy="clickAcceptIntranetBookmarkPrivacy"
          @close-intranet-bookmark-privacy-check-dialog="closeIntranetBookmarkPrivacyCheckDialog"
        />
      </div>

      <!-- 고객사 로고 -->
      <OfficeLogo v-if="viewType !== 'mobile'" />

      <div v-if="gnbRightSideShowReady" class="header-item header-item__right">
        <button
          v-show="!isSearchBoxVisible && searchType"
          class="icon-button"
          @click="
            setIsSearchBoxVisible();
            setPopoverMenuCloseAll();
          "
        >
          <i class="fal fa-search"></i>
        </button>

        <SearchBox
          v-show="isSearchBoxVisible"
          :domain="domain"
          :is-search-drop-down-visible="isSearchDropDownVisible"
          :search-type="searchType"
          class="grow"
          @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
          @set-is-search-box-visible="setIsSearchBoxVisible"
        />

        <InfoCenter
          v-show="secureInfoList.length"
          :domain="domain"
          :isInfoListVisible="isInfoListVisible"
          :secureInfoList="secureInfoList"
          @set-is-info-visible="setIsInfoListVisible"
        />

        <button
          :title="$t('더보기')"
          v-show="!isMoreMenusVisible && viewType !== 'desktop'"
          :class="{ new: !isReadNewNotice || notificationInfo.count > 0 }"
          class="icon-button more-button"
          @click="
            setIsMoreMenusVisibleByViewType();
            setPopoverMenuCloseAll();
          "
        >
          <i class="far fa-ellipsis-h"></i>
        </button>

        <div v-show="isMoreMenusVisible || viewType === 'desktop'" class="more-menus">
          <HelpDesk
            :helpNoticeFlag="isReadNewNotice"
            :isQnaVisible="isQnaVisible"
            @set-is-qna-visible="setQnaListVisible"
            @set-help-notice-flag-true="setHelpNoticeRead"
          />
          <Noti
            :isNotificationListVisible="isNotificationListVisible"
            :notificationCount="notificationInfo.count"
            :notificationList="notificationInfo.list"
            @load-notification="loadNotification"
            @set-is-notification-visible="setIsNotificationVisible"
            @read-notification="readNotification"
            @read-all-notification="readAllNotification"
          />
          <OrgTree />
          <ServiceTransition
            v-if="isUsePlatformMenu"
            :isVisible="isServiceTransitionVisible"
            @set-is-visible="setServiceTransitionVisible"
          />
          <Profile
            :domain="domain"
            :isProfileDetailVisible="isProfileDetailVisible"
            @set-profile-detail-visible="setProfileDetailVisible"
          />
          <button
            v-if="isMoreMenusVisible && viewType !== 'desktop'"
            class="close-button"
            @click="
              setPopoverMenuCloseAll();
              setIsMoreMenusVisible(false);
            "
          >
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import SecureApi from '@/api/secure-api';
import { mapGetters, mapState } from 'vuex';
import LinkedHwLogo from '@/components/LinkedHwLogo.vue';
import OfficeLogo from './OfficeLogo.vue';
import Menu from './Menu/Menu.vue';
import InfoCenter from './InfoCenter.vue';
import SearchBox from './Search/SearchBox.vue';
import Noti from './Noti.vue';
import HelpDesk from './HelpDesk.vue';
import Profile from './Profile/Profile.vue';
import { BREAK_POINTS, VIEW_TYPE } from '@/constants/index.ts';
import MyPlusAppApi from '@/api/my-plus-api';
import MyPlusApi from '@/api/my-plus-api';
import LinkApi from '@/api/link-api';
import IEServiceEndToast from '@/components/IEServiceEndToast/IEServiceEndToast.vue';
import ServiceTransition from '@/components/ServiceTransition.vue';
import { loadSecurityAlarmWrapper } from '@/js/loadSecurityAlram';
import OrgTree from '@/components/OrgTree.vue';

export default {
  name: 'Header',
  components: {
    OrgTree,
    ServiceTransition,
    LinkedHwLogo,
    OfficeLogo,
    Menu,
    SearchBox,
    HelpDesk,
    InfoCenter,
    Profile,
    Noti,
    IEServiceEndToast,
  },

  props: {
    searchType: {
      type: String,
      required: true,
    },
    menuName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isMenuVisible: false,
      timerID: null,
      isMenuDetailVisible: false,
      isProfileDetailVisible: false,
      isBookmarkOrderSettingVisible: false,
      isNotificationListVisible: false,
      bookmarkAddVisibleType: 1, /// 1: 기본, 2:생성, 3: 수정,
      isSearchDropDownVisible: false,
      isNotVisible: false,
      isInfoListVisible: false,
      isQnaVisible: false,
      secureInfoList: [],
      secureApiCalled: false,
      isShowPlusAppPrivacyDialog: false,
      selectedPlusApp: null,
      ssoId: null,
      privacyDocList: null,
      selectedIntranetBookmark: null,
      isShowIntranetBookmarkPrivacyDialog: false,
      isMoreMenusVisible: null,
      isSearchBoxVisible: null,
      viewType: null,
      isServiceTransitionVisible: false, // 서비스 전환 컴포넌트
    };
  },

  computed: {
    ...mapState({
      officeAccountInfo: (state) => state.office.officeAccountInfo,
      menuInfoList: (state) => state.menu.menuInfoList,
      intranetList: (state) => state.bookmark.intranetList,
      bookmarkList: (state) => state.bookmark.bookmarkList,
      groupList: (state) => state.group.groupList,
      notificationInfo: (state) => state.notification.notificationInfo,
      cacheOfficeInfo: (state) => state.cache.officeInfo,
      cacheUserInfo: (state) => state.cache.userInfo,
      myPlusAppList: (state) => state.plusapp.myPlusAppList,
      platformMenuInfoList: (state) => state.menu.platformMenuInfoList,
    }),
    ...mapGetters({
      isAdmin: 'cache/isAdmin',
      isUsePlatformMenu: 'cache/isShowPlatformMenu',
    }),
    domain() {
      if (!this.cacheOfficeInfo) {
        return '';
      }
      if (!this.cacheOfficeInfo.office) {
        return '';
      }
      return this.cacheOfficeInfo.office.office_id;
    },
    gnbRightSideShowReady() {
      return this.secureApiCalled;
    },

    isReadNewNotice() {
      return this.cacheUserInfo.notice_read_flag;
    },

    getCurrentEnv() {
      return `${process.env.VUE_APP_HIWORKS_ENV}`;
    },
    processedGroupList() {
      let list = this.groupList;

      this.menuInfoList.forEach((menuInfo) => {
        if (menuInfo.menu_type === 'GROUP_LINK' && !menuInfo.is_use) {
          list = [];
        }
      });
      return list;
    },

    isIE() {
      const userAgent = navigator.userAgent.toLowerCase();
      return userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1;
    },
  },

  watch: {
    isMenuVisible(isVisible) {
      if (!isVisible) {
        this.isMenuDetailVisible = false;
      }
    },
    cacheUserInfo(cacheUserInfo) {
      if (cacheUserInfo && cacheUserInfo.language) {
        this.$i18n.locale = cacheUserInfo.language;
      }
    },
  },

  created() {
    this.setLayout();
  },

  mounted() {
    this.init();
    window.addEventListener('resize', this.setLayout);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setLayout);
  },

  destroyed() {
    this.clearPreviewTimer();
  },

  methods: {
    visibilityChange(evt, hidden) {
      //! 비활성화 된 탭이 되거나 브라우저 숨김 모드가 되면 호출하지 않는다
      this.isNotVisible = hidden;
    },

    setIsSearchDropDownVisible(isVisible) {
      if (isVisible) {
        this.setPopoverMenuCloseAll();
      }
      this.isSearchDropDownVisible = isVisible;
    },
    hideMenu() {
      this.toggleMenu(false);
      this.setProfileDetailVisible(false);
    },
    async init() {
      await this.$store.dispatch('cache/loadUserInfo');
      await this.$store.dispatch('cache/loadOfficeInfo');
      await this.$store.dispatch('cache/loadOfficeCurrent');

      this.loadNotificationCount();
      this.loadSecureInfoList();

      // 멀티 오피스 사용 중일 때 호출
      if (this.$store.state.cache?.userInfo?.office?.is_multi_office === 1) {
        this.$store.dispatch('multiOffice/loadMultiAccounts');
      }

      this.secureApiCalled = true;
    },
    async loadSecureInfoList() {
      try {
        const result = await loadSecurityAlarmWrapper(SecureApi.loadSecureInfoList, this.cacheUserInfo.user_id);

        if (result) {
          const responseList = result;
          const mailBlockList = responseList.filter((item) => item.alarm_type === 'MAIL_BLOCK');
          const anotherList = responseList.filter((item) => item.alarm_type !== 'MAIL_BLOCK');

          this.secureInfoList = mailBlockList.concat(anotherList);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadNotificationCount() {
      await this.$store.dispatch('notification/loadCount'); // 최초 1회 웹 알림 count load 후

      setInterval(() => {
        // 60초마다 웹 알림 count 다시 load
        if (this.notificationInfo.count === 0 && !this.isNotVisible && !this.notificationInfo.isCountApiStop) {
          this.$store.dispatch('notification/loadCount');
        }
      }, 60_000);
    },
    readAllNotification() {
      this.$store.dispatch('notification/readAll');
    },
    async loadNotification() {
      this.clearPreviewTimer();

      await this.$store.dispatch('notification/loadList');

      this.timerID = setTimeout(() => {
        //! 리스트 요청시 자동으로 업데이트 되도록 변경 일단 주석처리
        // this.$store.dispatch('notification/loadCountRefresh', this.cacheOfficeInfo.office.office_id);
      }, 2000);
    },

    clearPreviewTimer() {
      if (this.timerID) {
        clearTimeout(this.timerID);
      }
    },
    async setHelpNoticeRead() {
      await this.$store.dispatch('cache/updateNoticeStateInfo');
      await this.$store.dispatch('cache/loadUserInfo');
    },

    readNotification(isRead, id, url) {
      if (!isRead) {
        this.$store.dispatch('notification/read', { id, params: {} }).then(() => {
          window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
    },
    toggleMenu(isVisible) {
      if (isVisible) {
        /// 메뉴가 보여질때만 call
        this.$store.dispatch('menu/loadMenuInfoList');
        this.$store.dispatch('menu/loadRecentCount');
        this.$store.dispatch('bookmark/loadBookmarkList');
        this.$store.dispatch('bookmark/loadIntranetList');
        this.$store.dispatch('group/loadGroupList');
        this.$store.dispatch('plusapp/fetchMyPlusAppList');
        this.$store.dispatch('banner/fetchMenuBanner');
      }
      this.isMenuVisible = isVisible;
    },
    setIsInfoListVisible(isVisible) {
      this.setPopoverMenuCloseAll();
      this.isInfoListVisible = isVisible;
      if (isVisible) this.isMoreMenusVisible = false;
    },
    setQnaListVisible(isVisible) {
      this.setPopoverMenuCloseAll();
      this.isQnaVisible = isVisible;
      if (isVisible) this.isMoreMenusVisible = true;
    },
    setProfileDetailVisible(isVisible) {
      this.setPopoverMenuCloseAll();
      this.isProfileDetailVisible = isVisible;
      if (isVisible) this.isMoreMenusVisible = true;
    },
    async setServiceTransitionVisible(isVisible) {
      if (!this.platformMenuInfoList.length && isVisible) {
        await this.$store.dispatch('menu/loadPlatformMenuInfoList');
      }

      this.setPopoverMenuCloseAll();
      this.isServiceTransitionVisible = isVisible;
      if (isVisible) this.isMoreMenusVisible = true;
    },
    setIsNotificationVisible(isVisible) {
      this.setPopoverMenuCloseAll();
      this.isNotificationListVisible = isVisible;
      if (isVisible) this.isMoreMenusVisible = true;
    },
    setPopoverMenuCloseAll() {
      this.isProfileDetailVisible = false;
      this.isInfoListVisible = false;
      this.isQnaVisible = false;
      this.isNotificationListVisible = false;
      this.isServiceTransitionVisible = false;
      this.$store.dispatch('notification/closeNotiPopover', null);
    },
    setMenuDetailVisible(isVisible) {
      this.isMenuDetailVisible = isVisible;
    },
    setMenuVisible(menuType, isVisible) {
      this.$store.dispatch('menu/setMenuVisible', { menuType, isVisible });
    },
    setIntranetVisible(bookmarkCategoriesNo, isVisible) {
      this.$store.dispatch('bookmark/setIntranetVisible', { bookmarkCategoriesNo, isVisible });
    },
    setBookmarkVisible(bookmarkCategoriesNo, isVisible) {
      this.$store.dispatch('bookmark/setBookmarkVisible', { bookmarkCategoriesNo, isVisible });
    },
    setGroupVisible(groupId, isVisible) {
      this.$store.dispatch('group/setGroupVisible', { groupId, isVisible });
    },
    async setMyPlusAppVisible(id, star) {
      await MyPlusAppApi.patchMyPlusApp(id, { star });

      this.$store.dispatch('plusapp/fetchMyPlusAppList');
    },

    setIsBookmarkOrderSettingVisible(isVisible) {
      this.isBookmarkOrderSettingVisible = isVisible;
    },
    setBookmarkAddVisibleType(type) {
      this.bookmarkAddVisibleType = type;
    },
    createBookmark(name, url) {
      this.$store.dispatch('bookmark/createBookmark', { name, url }).then(() => {
        this.setBookmarkAddVisibleType(1);
      });
    },
    modifyBookmark(no, name, url) {
      this.$store.dispatch('bookmark/modifyBookmark', { no, name, url }).then(() => {
        this.setBookmarkAddVisibleType(1);
      });
    },
    removeBookmark(no) {
      this.$store.dispatch('bookmark/removeBookmark', no);
    },
    modifyBookmarkOrder(noOrderList) {
      this.$store.dispatch('bookmark/modifyBookmarkOrder', noOrderList);
    },
    modifyMenuOrder(menuTypeList) {
      this.$store.dispatch('menu/modifyMenuOrder', menuTypeList);
    },

    // setIsSearchBoxVisible, setMoreIconsVisible 합치기
    setIsSearchBoxVisible() {
      this.isSearchBoxVisible = this.viewType === VIEW_TYPE.DESKTOP ? true : !this.isSearchBoxVisible;
    },
    setIsMoreMenusVisibleByViewType() {
      this.isMoreMenusVisible = this.viewType === VIEW_TYPE.DESKTOP ? true : !this.isMoreMenusVisible;
    },
    setIsMoreMenusVisible(isMoreMenusVisible) {
      this.isMoreMenusVisible = isMoreMenusVisible;
    },
    setLayout() {
      const [lastViewType, viewType] = this.setViewType();
      const isViewtypeChanged = lastViewType !== viewType;
      const isRelatedToDesktop = lastViewType === VIEW_TYPE.DESKTOP || viewType === VIEW_TYPE.DESKTOP;

      if (isViewtypeChanged && isRelatedToDesktop) {
        this.isSearchBoxVisible = this.viewType === VIEW_TYPE.DESKTOP ? true : false;

        const isAllMoreMenuDropdownClosed = !(
          this.isQnaVisible ||
          this.isNotificationListVisible ||
          this.isProfileDetailVisible
        );

        if (isAllMoreMenuDropdownClosed && this.isMoreMenusVisible) {
          this.setIsMoreMenusVisible(false);
        }
      }
    },

    setViewType() {
      const newViewType = window.matchMedia(`screen and (min-width: ${BREAK_POINTS.DESKTOP.MIN}px)`).matches
        ? VIEW_TYPE.DESKTOP
        : window.matchMedia(
            `(min-width: ${BREAK_POINTS.TABLETTE.MIN}px) and (max-width: ${BREAK_POINTS.TABLETTE.MAX}px`,
          ).matches
        ? VIEW_TYPE.TABLETTE
        : VIEW_TYPE.MOBILE;
      const actualViewType = this.viewType;
      if (actualViewType !== newViewType) this.viewType = newViewType;
      return [actualViewType, newViewType];
    },

    setMobileLayout() {
      //! input 창이 focus가 안되었는지 체크 필요
      // 모바일 레이아웃 적용
      this.isSearchBoxVisible = false;
    },

    setDesktopLayout() {
      // 데스크탑 레이아웃 적용
      this.isSearchBoxVisible = true;
    },
    async clickPlusApp(myPlusApp) {
      if (myPlusApp.checked_privacy) window.open(`${myPlusApp.office_app.link_url}/redirect`);
      else {
        this.selectedPlusApp = myPlusApp;
        const plusAppResponse = await MyPlusApi.getMyPlusApp(myPlusApp.app_id);
        const { services } = plusAppResponse.data.data;
        const ssoId = services.find(({ type }) => type === 'SSO').config.sso_link_id;

        if (ssoId) {
          this.ssoId = ssoId;
          const response = await LinkApi.getPrivacyDoc(ssoId);
          this.privacyDocList = response.data.data;
          if (response.status === 200) {
            this.isShowPlusAppPrivacyDialog = true;
          }
        }
      }
    },
    closePlusPrivacyCheckDialog() {
      this.isShowPlusAppPrivacyDialog = false;
    },
    async clickAcceptPlusAppPrivacy(selectedPlusApp) {
      try {
        await LinkApi.acceptPrivacy({ link_no: this.ssoId });
        await MyPlusAppApi.patchMyPlusApp(selectedPlusApp.id, { privacy: true });
        this.closePlusPrivacyCheckDialog();
        window.open(`${selectedPlusApp.office_app.link_url}/redirect`);
        this.$store.dispatch('plusapp/fetchMyPlusAppList');
      } catch (error) {
        console.error(error);
        window.alert('개인정보 제공 동의에 실패했습니다.');
      }
    },
    async clickIntranet(bookmark) {
      if (bookmark.use_sso === 'Y') {
        const isAgreeResponse = await LinkApi.getPrivacyAgreement(bookmark.sso_link_id);
        if (isAgreeResponse.data.data[0].agreement === true) {
          const ssoUrl = `${process.env.VUE_APP_HIWORKS_LINK_API}/links/${bookmark.sso_link_id}/redirect`;
          window.open(ssoUrl);
        } else {
          this.selectedIntranetBookmark = bookmark;
          const privacyDocResponse = await LinkApi.getPrivacyDoc(bookmark.sso_link_id);
          this.privacyDocList = privacyDocResponse.data.data;

          if (privacyDocResponse.status === 200) {
            this.isShowIntranetBookmarkPrivacyDialog = true;
          }
        }
      } else {
        let urlPattern = /^(http|https):/;
        urlPattern.test(bookmark.url) ? window.open(bookmark.url) : window.open('http://' + bookmark.url);
      }
    },
    async clickAcceptIntranetBookmarkPrivacy(bookmark) {
      const response = await LinkApi.acceptPrivacy({ link_no: +bookmark.sso_link_id });

      if (response.status === 201) {
        const ssoUrl = `${process.env.VUE_APP_HIWORKS_LINK_API}/links/${bookmark.sso_link_id}/redirect`;
        window.open(ssoUrl);
        this.isShowIntranetBookmarkPrivacyDialog = false;
        this.$store.dispatch('bookmark/loadIntranetList');
      } else {
        window.alert('개인정보 제공 동의에 실패했습니다.');
      }
    },
    closeIntranetBookmarkPrivacyCheckDialog() {
      this.isShowIntranetBookmarkPrivacyDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'https://static.hiworks.com/fonts/icons/v1.0.1/style.css';
@import '@/assets/scss/base/variables.scss';

.new_gnb {
  // hiworksReset.scss를 gnb 한정으로 적용, legacyReset이 예상치 못한 문제점을 발생시키기 때문.
  // legacyReset을 사용하는 프로젝트를 모두 개편하게 되면 삭제 할 수 있음.
  ::v-deep dl,
  ::v-deep ul,
  ::v-deep ol,
  ::v-deep menu,
  ::v-deep li {
    list-style: none;
  }

  ::v-deep blockquote,
  ::v-deep q {
    quotes: none;
  }

  ::v-deep blockquote:before,
  ::v-deep blockquote:after,
  ::v-deep q:before,
  ::v-deep q:after {
    content: '';
    content: none;
  }

  ::v-deep input,
  ::v-deep select,
  ::v-deep textarea,
  ::v-deep button {
    vertical-align: middle;
  }

  ::v-deep input::-ms-clear {
    display: none;
  }

  ::v-deep a {
    text-decoration: none;
  }

  ::v-deep a:hover {
    text-decoration: none;
  }

  ::v-deep address,
  ::v-deep caption,
  ::v-deep cite,
  ::v-deep code,
  ::v-deep dfn,
  ::v-deep em,
  ::v-deep var {
    font-style: normal;
    font-weight: normal;
  }

  ::v-deep label {
    margin-bottom: 0 !important;
  }

  ::v-deep *,
  ::v-deep *:before,
  ::v-deep *:after {
    box-sizing: border-box;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .new_header {
    box-sizing: border-box;
    z-index: 200;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0 20px;
    height: $headerHeight;
    border-bottom: 1px solid #dadce0;
    background: #fff;

    display: flex;
    align-items: center;
    width: 100%;
    gap: 30px;

    @media only screen and (min-width: 900px) {
      padding: 0 24px;
    }

    .header-item {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;

      & > * {
        flex-shrink: 0;
      }

      &.header-item__left {
        @media only screen and (min-width: 900px) {
          gap: 12px;
        }
      }

      &.header-item__right {
        justify-content: flex-end;
        gap: 12px;

        & > .grow {
          flex-grow: 1;
        }

        @media only screen and (min-width: 900px) and (max-width: 1279px) {
          position: relative;
        }
      }
    }

    .icon-button {
      width: $iconButtonSize;
      height: $iconButtonSize;
      font-size: 20px;
      color: #909090;
      border-radius: 4px;
    }

    ::v-deep.icon-button__selected {
      background-color: rgba(159, 166, 173, 0.2);
    }

    .icon-button:hover {
      &:hover {
        background-color: #ecedef;
      }
    }

    .more-button {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      & i {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1.9px solid #909090;
        border-radius: 100%;
        font-size: 12px;
        box-sizing: border-box;
      }
    }

    .more-button.new::before {
      position: absolute;
      content: '';
      top: 4px;
      right: 0;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #1f8ce8;
      z-index: 1;
    }

    .more-menus {
      //! 헤더 스타일 복사 .new_header
      position: fixed;
      height: $headerHeight;
      padding: 0 20px 0 20px;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      gap: 12px;
      border-bottom: 1px solid #dadce0;
      background: #fff;
      font-size: 14px;
      box-sizing: border-box;

      & > div {
        width: 100%;
        display: flex;
        justify-content: center;
      }

      .close-button {
        width: $iconButtonSize;
        height: $iconButtonSize;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 0;
        flex-shrink: 0;
        color: #909090;

        & i {
          font-size: 18px;
        }
      }

      @media only screen and (min-width: 900px) and (max-width: 1279px) {
        position: absolute;
        padding: 0;
        justify-content: flex-end;
        gap: 12px;

        & > div {
          width: auto;
        }
      }

      @media (min-width: 1280px) {
        position: static;
        // margin-right: 4px;
        padding: 0;
        height: auto;
        border: none;
        gap: 12px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
$HW_MODAL_SIZES: (
  sm: 500,
  md: 600,
  lg: 700,
);

::v-deep .hw-modal-wrap {
  position: inherit;
  z-index: 1010;
  padding: 25px;
  border: 1px solid #707070;
  background: #fff;
  color: #333;
  box-sizing: border-box;

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  @each $size, $px in $HW_MODAL_SIZES {
    &.size-#{$size} {
      width: #{$px}px;
    }
  }

  .gt-list-dot > li:before {
    color: #909090;
  }
}
</style>
